import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, exhaustMap, map, mapTo, mergeMap, mergeMapTo } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import * as headerActions from './header.actions';



@Injectable()
export class HeaderEffects {

  signoutGame360$ = createEffect(() => this.actions$.pipe(
    ofType(headerActions.signOut),
    mergeMap(() => this.authService.signout()
      .pipe(
        map(resp => ({type: headerActions.signOutSuccessful.type, payload: resp})),
        catchError(() => EMPTY)
      )
    )
  ));

  constructor(
    private authService: AuthService,
    private actions$: Actions) {}

}
